import Triword from './Triword';

export default Triword;